import React from 'react';
import '../css/Section.css';

function PrivacyPolicy() {
  return (
    <main className="privacy-page">
      <section className="privacy-hero">
        <p className="eyebrow">Privacy Policy</p>
        <h1>Aevolt Energy Privacy Policy</h1>
        <p>
          Last updated: June 6, 2026
        </p>
      </section>

      <section className="privacy-content" aria-label="Privacy policy details">
        <article>
          <h2>Information We Collect</h2>
          <p>
            We may collect your name, phone number, WhatsApp number, product
            interest, delivery location, and any message details you send when
            you contact Aevolt Energy, request a call, or place an order.
          </p>
        </article>

        <article>
          <h2>How We Use Information</h2>
          <p>
            We use your information to respond to inquiries, process product
            requests, arrange consultations, provide customer support, improve
            our services, and communicate updates related to Aevolt Energy
            products and services.
          </p>
        </article>

        <article>
          <h2>WhatsApp And External Links</h2>
          <p>
            Our website may open WhatsApp or social media links so you can
            contact us directly. Those services are operated by third parties,
            and their own privacy policies apply when you use them.
          </p>
        </article>

        <article>
          <h2>Sharing Information</h2>
          <p>
            We do not sell your personal information. We may share information
            only when needed to provide services, complete an order, comply with
            legal requirements, or protect our business and customers.
          </p>
        </article>

        <article>
          <h2>Data Security</h2>
          <p>
            We take reasonable steps to protect the information you provide.
            However, no website, messaging service, or internet transmission is
            completely secure.
          </p>
        </article>

        <article>
          <h2>Your Choices</h2>
          <p>
            You can contact us to request access, correction, or deletion of
            your personal information, subject to any records we need to keep
            for legitimate business or legal reasons.
          </p>
        </article>

        <article>
          <h2>Contact Us</h2>
          <p>
            For privacy questions or requests, contact Aevolt Energy through
            the WhatsApp contact options provided on this website.
          </p>
        </article>
      </section>
    </main>
  );
}

export default PrivacyPolicy;
